module.exports = __webpack_public_path__ + "img/book_open.602d2873.svg";